import React, { FC, useState } from 'react';
import styled from "src/theme";
import { Row, Col, Dropdown } from 'antd';
import { ForwardRefButton, Switch } from 'src/components/UI';
import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

import { PicketParameters } from './PicketParameters';
import { PailingParameters } from './PailingParameters';

export const Parameters: FC = () => {
  const [visible, setVisible] = useState(false);

  const { dispatch, fenceStore } = useStoreon<IState, IEvents>('fenceStore');

  const handleChange = (checked: boolean) => {
    dispatch('fence/set-fence-type', { fenceType: checked ? 'picket' : 'pailing' });
  };

  return (
    <ParametersRowStyled>
      <Col xs={24} md={11}>
        <Row justify='space-between' align="middle">
          <Col>
            <Dropdown
              overlay={fenceStore.fenceType === 'picket' ? <PicketParameters /> : <PailingParameters />}
              key={fenceStore.fenceType === 'picket' ? 'picket' : 'pailing'}
              trigger={['click']}
              visible={visible}
              onVisibleChange={(flag) => setVisible(flag)}
            >
              <ForwardRefButton style={{ minWidth: '240px' }}>{`Параметры ${ fenceStore.fenceType === 'picket' ? 'штакетника' : 'профнастила' }`}</ForwardRefButton>
            </Dropdown>
          </Col>
          <ColumnSwitchStyled>Профнастил <Switch onChange={handleChange} /> Штакетник</ColumnSwitchStyled>
        </Row>
      </Col>
    </ParametersRowStyled>
  );

};

const ParametersRowStyled = styled(Row)`
  margin-bottom: 32px;
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    margin-bottom: 0;
  }
`;

const ColumnSwitchStyled = styled(Col)`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  margin: 9px 0;
  font-size: 12px;
  line-height: 14px;
  color: #212121;
  .ant-switch {
    margin: 0 8px;
  }
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    justify-content: flex-end;
    margin: 16px 0;
  }
`;

// const ColumnLabelStyled = styled(Col)`
//   display: flex;
//   min-height: 32px;
//   align-items: center;
// `;
//
// const LabelTextStyled = styled.span`
//   margin-top: 8px;
//   width: 100%;
//   text-align: center;
//   font-style: normal;
//   font-weight: normal;
//   font-size: 14px;
//   line-height: 16px;
//   letter-spacing: 0.01em;
//   color: #000000;
// `;
